import { Api } from "services";
import axios from "axios";

export const UPDATE_ORG_DETAILS_KYC = "UPDATE_ORG_DETAILS_KYC";
export const SHOW_KYC_PENDING_MODAL = "SHOW_KYC_PENDING_MODAL";
export const SHOW_KYC_APPROVAL_PENDING_MODAL = "SHOW_KYC_APPROVAL_PENDING_MODAL";


export const fetchPinCodeDetails = (pin, callback) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const request = {
        method: 'get',
        url: `https://nominatim.openstreetmap.org/search?postalcode=${pin}&country=India&format=json&addressdetails=1`,
        headers: { 'User-Agent': 'AulasApp/1.0' },
      };
      axios(request)
      .then((response) => {
        const data = response.data || [];
        // Normalize to match the original postalpincode.in shape:
        // [{ Status, PostOffice: [{ Name, District, State, Country, Pincode }] }]
        const normalized = {
          Status: data.length > 0 ? 'Success' : 'Error',
          PostOffice: data.map(item => ({
            Name: item.address?.city || item.address?.county || item.address?.town || item.address?.village || '',
            District: item.address?.city || item.address?.county || item.address?.town || item.address?.village || '',
            State: item.address?.state || '',
            Country: item.address?.country || 'India',
            Pincode: pin,
          })),
        };
        console.log("Pincode API res", normalized);
        callback([normalized]);
      })
      .catch((error) => {
        console.log(error);
      });
    });
  };
}

export const showApprovalPendingModal = (bool) => ({
  type: 'SHOW_KYC_APPROVAL_PENDING_MODAL',
  bool
})

export const showKycPendingModal = (bool) => ({
  type: 'SHOW_KYC_PENDING_MODAL',
  bool
})

export const postKycDetails = (params, callback, successCallBack) => {
    return (dispatch, getState) => {
        Object.keys(params).forEach(key => {
          if (params[key] === null) {
            delete params[key];
          }
        });
        return new Promise((resolve, reject) => {
          Api.post("/fee/updateKyc")
            .params(params)
            // The backend's response.show.popup already gets replaced by our own
            // "KYC Under Review" page (kycSuccess.js) right after this call succeeds,
            // so suppress the generic popup or it shows on top of/before that page.
            .suppressSnackbar()
            .send(async (response, error) => {
              callback()
              if(response && response.show && response.show.type === "success"){
                  // history.push('/kyc-form-submitted')
                  successCallBack()
              }
              
            });
        });
      };
}

export const uploadDocument = (file, key, callback, successCallback) => {
    return (dispatch) => {
            const params = {
                file, key, type: "Image"
            }
            console.log("Req", params);
            return Api.post(`/fee/files`).upload(params, (percent, response) => {
              if(response !== undefined){
                console.log(response);
                if(percent === 100){
                    callback();
                    let type = "image"
                    if(response?.data?.file.split('.')[response?.data?.file.split('.').length -1] === "pdf"){
                      type = "pdf"
                    }
                    successCallback(response?.data?.file, type);
                }
              }
              if(percent === -1){
                callback()
            }
              
            });
            
          }
}

const updateOrgDetails = data => ({
    type: UPDATE_ORG_DETAILS_KYC,
    data
})

export const getOrgDetails = (callback, history) => {
    return (dispatch, getState) => {
      return new Promise((resolve, reject) => {
        Api.get("/fee/kyc")
          .send(async (response, error) => {
            if(response && response.kyc === 'submitted'){
              // Preserve wherever the KYC flow was originally entered from (account
              // settings / fee management) across this redirect, so the "KYC Under
              // Review" page's back icon still returns there instead of defaulting.
              return history.push('/kyc-form-submitted', { from: history.location?.state?.from })
            }
            callback(response?.kyc)
            if (typeof response !== "undefined") {
             dispatch(updateOrgDetails(response))
            }
          });
      });
    };
  };
  